import {ConfigType, PModuleType} from '@/enums/configs';
import {VueConstructor} from 'vue';
import {ConfigTypeSpectrumValueInfo} from './nodeApi';
import DtcpTahoModuleForm from '@v/system/modules/forms/dtcp/DtcpTahoModuleForm.vue';
import CrmModuleForm from '@v/system/modules/forms/CrmModuleForm.vue';
import CleanStorageModuleForm from '@v/system/modules/forms/CleanStorageModuleForm.vue';
import ServerMonitorModuleForm from '@v/system/modules/forms/ServerMonitorModuleForm.vue';
import DtcpServerModuleForm from '@v/system/modules/forms/dtcp/DtcpServerModuleForm.vue';
import DtcpEnergyModuleForm from '@v/system/modules/forms/dtcp/DtcpEnergyModuleForm.vue';
import DtcpTemperatureModuleForm from '@v/system/modules/forms/dtcp/DtcpTemperatureModuleForm.vue';
import DtcpAccelerometerModuleForm from '@v/system/modules/forms/dtcp/DtcpAccelerometerModuleForm.vue';
import HeaterMonitorModuleForm from '@v/system/modules/forms/HeaterMonitorModuleForm.vue';
import BearingControlModuleForm from '@v/system/modules/forms/BearingControlModuleForm.vue';
import PingerModuleForm from '@v/system/modules/forms/PingerModuleForm.vue';
import DtcpEmulatorModuleForm from '@v/system/modules/forms/dtcp/DtcpEmulatorModuleForm.vue';
import {SpectrumEventType, SpectrumYAxisType} from '@/enums/diagrams';
import {getSpectrumEventTypeNumberStr} from '@c/diagrams/utils';
import MonitorTaskForm from '@v/system/modules/forms/MonitorTaskForm.vue';

/*
TODO: Эти данные должны приходить с сервера
*/

/*
  Значения полей по спектрам для программных модулей
*/

export const spectrumValueInfoes: Map<ConfigType, ConfigTypeSpectrumValueInfo[]> = new Map<
  ConfigType,
  ConfigTypeSpectrumValueInfo[]
>([
  [ConfigType.OrTahoModule, []],
  [ConfigType.OrCrmModule, []],
  [
    ConfigType.OrEnergyModule,
    [
      {
        eventType: getSpectrumEventTypeNumberStr(SpectrumEventType.Low),
        yAxisDesc: 'Амплитуда',
        unit: 'А',
        spectrumName: 'Спектр низких частот',
      },
    ],
  ],
  [
    ConfigType.OrAccelerometerModule,
    [
      {
        eventType: getSpectrumEventTypeNumberStr(SpectrumEventType.Low),
        yAxisDesc: 'Виброускорение',
        unit: 'м/c²',
        spectrumName: 'Спектр низких частот',
      },
      {
        eventType: getSpectrumEventTypeNumberStr(SpectrumEventType.Envelop),
        yAxisDesc: 'Виброускорение',
        unit: 'дБ',
        spectrumName: 'Спектр огибающей высоких частот',
      },
    ],
  ],
]);

/*
  Список типов
*/

export interface TypeData {
  id: string;
  name: string;
  type: any;
  enabled?: boolean;
}

/*
    Словарь биндинга компонент форм добавления датчиков
*/
export const moduleTypeFormComponentBindingMap: Map<PModuleType, VueConstructor | null> = new Map<
  PModuleType,
  VueConstructor | null
>([
  [PModuleType.DtcpTahoModule, DtcpTahoModuleForm],
  [PModuleType.CrmModule, CrmModuleForm],
  [PModuleType.DtcpServerModule, DtcpServerModuleForm],
  [PModuleType.DtcpEnergyModule, DtcpEnergyModuleForm],
  [PModuleType.DtcpTemperatureModule, DtcpTemperatureModuleForm],
  [PModuleType.DtcpAccelerometerModule, DtcpAccelerometerModuleForm],
  [PModuleType.HeaterMonitorModule, HeaterMonitorModuleForm],
  [PModuleType.CleanStorageModule, CleanStorageModuleForm],
  [PModuleType.ServerMonitorModule, ServerMonitorModuleForm],
  [PModuleType.BearingControlModule, BearingControlModuleForm],
  [PModuleType.PingerModule, PingerModuleForm],
  [PModuleType.DtcpEmulatorModule, DtcpEmulatorModuleForm],
  [PModuleType.MonitorStatesTasks, MonitorTaskForm],
  [PModuleType.MonitorBoundaryTasks, MonitorTaskForm],
  [PModuleType.MonitorChildTasks, MonitorTaskForm],
]);

/* Список перечисления Тип оси спектра */
export const spectrumYAxisTypes: {value: SpectrumYAxisType; name: string}[] = [
  {value: SpectrumYAxisType.VDecibels, name: 'Виброускорение, дБ(А)'},
  {value: SpectrumYAxisType.VAcceleration, name: 'Виброускорение, м/с²'},
  {value: SpectrumYAxisType.VVelocity, name: 'Виброскорость, мм/с'},
];
